import { FluxStandardAction } from "__utils/type";
import * as Actions from "../../constants/actions";

export const fetchAgentDetails = (agentCode: string): FluxStandardAction => {
    return {
        type: Actions.FETCH_GET_AGENT_DETAILS,
        payload: {
            data: agentCode
        }
    }
};

export const fetchAgentDetailsSuccess = (data: any): FluxStandardAction => {
    return {
        type: Actions.FETCH_GET_AGENT_DETAILS_SUCCESS,
        payload: {
            data: data
        }
    }
};

export const fetchAgentDetailsError = (error: any): FluxStandardAction => {
    return {
        type: Actions.FETCH_GET_AGENT_DETAILS_ERROR,
        payload: {
            data: error
        }
    }
};

export const fetchAgentCertificates = (agentCode: string): FluxStandardAction => {
    return {
        type: Actions.FETCH_GET_AGENT_CERTIFICATES,
        payload: {
            data: agentCode
        }
    }
};

export const fetchAgentCertificatesSuccess = (data: any): FluxStandardAction => {
    return {
        type: Actions.FETCH_GET_AGENT_CERTIFICATES_SUCCESS,
        payload: {
            data: data
        }
    }
};
export const fetchAgentProfilePic = (agentCode: string): FluxStandardAction => {
    return {
        type: Actions.FETCH_GET_AGENT_PROFILE_PIC,
        payload: {
            data: agentCode
        }
    }
};

export const fetchAgentProfilePicSuccess = (fileDetails: any): FluxStandardAction => {
    return {
        type: Actions.FETCH_GET_AGENT_PROFILE_PIC_SUCCESS,
        payload: {
            data :fileDetails
        }
    }
};

export const fetchUserProfileInfo = (): FluxStandardAction => {
    return {
        type: Actions.FETCH_GET_USER_PROFILE_INFO,       
    }
};
export const fetchUserProfileInfoSuccess = (data: any): FluxStandardAction => {
    return {
        type: Actions.FETCH_GET_USER_PROFILE_INFO_SUCCESS,
        payload: {
            data: data
        }
        
    }
};
export const fetchUserProfileInfoError = (error:any): FluxStandardAction => {
    return {
        type: Actions.FETCH_GET_USER_PROFILE_INFO_ERROR,
        payload: {
            data: error
        }
        
    }
};
export const fetchDiwaliGiftPdf = (language:string): FluxStandardAction => {    
    return {
        type: Actions.FETCH_GET_DIWALI_PDF,
        payload: {
            data: language
        }
        
    }
};
export const fetchDiwaliGiftPdfSuccess = (pdfDetails: any): FluxStandardAction => {
    return {
        type: Actions.FETCH_GET_DIWALI_PDF_SUCCESS,
        payload: {
            data: pdfDetails
        }
        
    }
};
export const fetchCustomerCount = (agentCode: string): FluxStandardAction => {
    return {
        type: Actions.FETCH_GET_CUSTOMER_COUNT,
        payload: {
            data: agentCode
        }
        
    }
};
export const fetchAgentVerification = (agentCode: string): FluxStandardAction => {
    return {
        type: Actions.FETCH_GET_AGENT_VERIFICATION,
        payload: {
            data: agentCode
        }
        
    }
};
export const fetchAgentVerificationSuccess = (nonArn: boolean): FluxStandardAction => {
    return {
        type: Actions.FETCH_GET_AGENT_VERIFICATION_SUCCESS,
        payload: {
            data: nonArn
        }
        
    }
};
export const fetchCustomerCountSuceess = (customerAumDetails: any): FluxStandardAction => {
    return {
        type: Actions.FETCH_GET_CUSTOMER_COUNT_SUCCESS,
        payload: {
            data: customerAumDetails
        }
        
    }
};
export const fetchCustomerOrderDetails = (): FluxStandardAction => {
    return {
        type: Actions.FETCH_GET_CUSTOMER_ORDER_DETAILS,
        
    }
};
export const fetchCustomerOrderDetailsSuccess = (orderDetails: any): FluxStandardAction => {
    return {
        type: Actions.FETCH_GET_CUSTOMER_ORDER_DETAILS_SUCCESS,
        payload: {
            data: orderDetails
        }
        
    }
};
export const fetchGetCalculatorLeadsCount = (): FluxStandardAction => {
    return {
        type: Actions.FETCH_GET_CALCULATOR_LEADS_COUNT,
        
    }
};
export const fetchGetCalculatorLeadsCountSuccess = (leadCount: any): FluxStandardAction => {
    return {
        type: Actions.FETCH_GET_CALCULATOR_LEADS_COUNT_SUCCESS,
        payload: {
            data: leadCount
        }
        
    }
};
export const fetchPostMergeCarts = (isBtoCFlow: boolean): FluxStandardAction => {
    return {
        type: Actions.FETCH_POST_MERGE_CARTS,
        payload: {
            isBtoCFlow: isBtoCFlow
        }
        
    }
};
export const fetchPostMergeCartsSuccess = (response: any): FluxStandardAction => {
    return {
        type: Actions.FETCH_POST_MERGE_CARTS_SUCCESS,
        payload: {
            data: response
        }
        
    }
};
